export namespace NPage {
  export type Main = (props: {
    children?: JSX.Element;
    headerContent?: JSX.Element;
    headerNavigationContent?: JSX.Element;
    disableBreadcrumbs?: boolean;
    secondLevelData?: LevelDataModel;
    thirdLevelData?: LevelDataModel;
    contentLayoutClassName?: string;
    goBackRoute?: string;
    hideBackButton?: boolean;
    disableContentStyles?: boolean;
    mobileTitle?: string;
  }) => JSX.Element;

  export type LevelDataModel = {
    title: string | JSX.Element;
    path: string;
    disabled?: boolean;
    disablingTooltip?: string | null;
  };

  export enum MenuSidebarState {
    FULL = 'full',
    SMALL = 'small',
    NONE = 'none',
  }
}
